//TODO: Need to add the category ids of the other product types...
export const GAME_PRODUCT_TYPES = {
    PARASITICIDE: "Parasiticide",
    DENTAL: "Dental",
    NSAID: "NSAID",
    THERAPEUTIC: "Therapeutic"
};
